import PropTypes from 'prop-types';

Area.propTypes = {
  area: PropTypes.number,
};

export default function Area({area}) {
  if (!area) {
    return <span>-</span>;
  }
  const hectares = area / 10000;
  if (hectares >= 1) {
    return <span>{hectares.toFixed(2)}ha</span>;
  }

  return <span>{area}m<sup>2</sup></span>;
}
